export enum CategoryType {
    convo = 'convo',
    channel = 'channel',
}
